var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ability-course"},[_vm._v("课程能力图谱")])
}
var staticRenderFns = []

export { render, staticRenderFns }